import React, {useState} from "react";
import {SetStateFn} from "@/utils/SetStateUtils";
import {ConfirmModal, useNotifications} from "peggirkit";
import {globalConfirmModalProps} from "@/utils/ModalUtils";
import {FormattedMessage, useIntl} from "react-intl";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {DateRange} from "react-day-picker";
import {formatDate} from "@/utils/DateUtils";
import {EmployeeInReport} from "@/data/entities/employee";
import {exportCsv} from "@widgets/reports/timesheet/export/export";


type Props = {
    dateRange: DateRange,
    show: boolean,
    setShow: SetStateFn<boolean>,
    data: EmployeeInReport[],
};

const ExportTimesheetModal = ({show, setShow, dateRange, data}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const [loading, setLoading] = useState(false);
    const {dashboardLocation} = useRestaurant();


    return (
        <ConfirmModal
            {...globalConfirmModalProps(intl)}
            show={show}
            onClose={() => setShow(false)}
            title={intl.formatMessage({id: "exportHoursWorked"})}
            type={"info"}
            continueButton={{
                text: intl.formatMessage({id: "continue"}),
                onClick: () => exportCsv({
                    setLoading,
                    setShow,
                    data,
                    dashboardLocation,
                    dateRange,
                    notify,
                    intl,
                })
            }}
            disabled={loading}
            loading={loading}
        >
            <FormattedMessage
                id={"exportHoursWorked.description"}
                values={{
                    location: (
                        <strong className={"font-bold"}>
                            {dashboardLocation.name}
                        </strong>
                    ),
                    start: (
                        <strong className={"font-bold"}>
                            {formatDate(dateRange.from || new Date())}
                        </strong>
                    ),
                    end: (
                        <strong className={"font-bold"}>
                            {formatDate(dateRange.to || new Date())}
                        </strong>
                    ),
                }}
            />
        </ConfirmModal>
    );
};

export default ExportTimesheetModal;